"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RoundedButton = function RoundedButton(_ref) {
  var icon = _ref.icon,
      iconType = _ref.iconType,
      size = _ref.size,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["icon", "iconType", "size", "onClick", "type", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledRoundedButton, _extends({
    onClick: onClick,
    className: className,
    type: type,
    iconType: iconType,
    size: size
  }, otherProps), icon);
};

var StyledRoundedButton = _styledComponents.default.div.withConfig({
  displayName: "StyledRoundedButton"
})(["width:", ";height:", ";background:white;border:1px solid #f0f1f3;box-sizing:border-box;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);border-radius:9999px;cursor:pointer;transition:all 0.15s ease-in-out;display:flex;justify-content:center;align-items:center;svg path{stroke:", ";fill:", ";transition:stroke 0.15s ease-in-out;}&:hover{background:", ";border:1px solid ", ";box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 16px 24px rgba(0,0,0,0.06);svg path{stroke:", ";fill:", ";}}"], function (_ref2) {
  var size = _ref2.size;
  return size === 'large' ? '5rem' : size === 'small' ? '1.6rem' : '3.2rem';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'large' ? '5rem' : size === 'small' ? '1.6rem' : '3.2rem';
}, function (_ref4) {
  var theme = _ref4.theme,
      type = _ref4.type,
      iconType = _ref4.iconType;
  return iconType === 'fill' ? null : type === 'default' ? theme.ui.outline : type === 'primary' ? theme.brand.primary : type === 'warning' ? theme.status.warning : type === 'success' ? theme.status.succes : type === 'danger' ? theme.status.error : theme.ui.outline;
}, function (_ref5) {
  var theme = _ref5.theme,
      type = _ref5.type,
      iconType = _ref5.iconType;
  return iconType === 'stroke' ? null : type === 'default' ? theme.ui.outline : type === 'primary' ? theme.brand.primary : type === 'warning' ? theme.status.warning : type === 'success' ? theme.status.succes : type === 'danger' ? theme.status.error : theme.ui.outline;
}, function (_ref6) {
  var theme = _ref6.theme,
      type = _ref6.type;
  return type === 'default' ? theme.brand.primary : type === 'primary' ? theme.brand.primary : type === 'warning' ? theme.status.warning : type === 'success' ? theme.status.succes : type === 'danger' ? theme.status.error : theme.brand.primary;
}, function (_ref7) {
  var theme = _ref7.theme,
      type = _ref7.type;
  return type === 'default' ? theme.brand.primary : type === 'primary' ? theme.brand.primary : type === 'warning' ? theme.status.warning : type === 'success' ? theme.status.succes : type === 'danger' ? theme.status.error : theme.brand.primary;
}, function (_ref8) {
  var iconType = _ref8.iconType;
  return iconType === 'fill' ? null : 'white';
}, function (_ref9) {
  var iconType = _ref9.iconType;
  return iconType === 'stroke' ? null : 'white';
});

RoundedButton.defaultProps = {
  type: 'default',
  iconType: 'stroke',
  size: 'default'
};
RoundedButton.propTypes = {
  /** A React component to be displayed inside the button. (If using an icon from wg-fe-ui, set size to 20) */
  icon: _propTypes.element.isRequired,

  /** Defines wether an icon should be colored by fill or by stroke. */
  iconType: _propTypes.string,

  /** Set a predefined size based on types. (Options: 'small', 'large') */
  size: _propTypes.string,

  /** The onClick function to be called when the button is clicked. */
  onClick: _propTypes.func,

  /** Set a predefined color scheme based on action types. (Options: 'default', 'primary', 'warning', 'success', 'danger') */
  type: _propTypes.string,

  /** Extra classNames to be passed to the StyledRoundedButton. */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = RoundedButton;
exports.default = _default;